import React from "react";
function FooterList(props) {
    const id = props.list[0].id;
    let Item = props.list.map ((col, idx) =>
    {    
        return ( 
            <ul key={idx} className="footer__list ">
                <li className="footer__list-item">
                    <a href={col.href}>{col.text}</a>
                    <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.4459 0.640949C10.4459 0.394722 10.2463 0.195116 10 0.195115L5.98754 0.195116C5.74131 0.195116 5.54171 0.394722 5.54171 0.640949C5.54171 0.887176 5.74131 1.08678 5.98754 1.08678L9.55421 1.08678L9.55421 4.65345C9.55421 4.89968 9.75381 5.09928 10 5.09928C10.2463 5.09928 10.4459 4.89968 10.4459 4.65345L10.4459 0.640949ZM1.39863 9.87287L10.3153 0.956201L9.68479 0.325697L0.768122 9.24237L1.39863 9.87287Z" fill="black"/>
                    </svg>
                </li>
            </ul>
    )});
return (
    <div id={id}>{Item}</div>
)}
export default FooterList;